import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { ShareViewer } from './components/ShareViewer'
import { FestivalShareViewer } from './components/FestivalShareViewer'
import { initMockData } from './data/mockData'
import { cleanupLegacyLocalStorage } from './lib/db'
import { ensureSyncConfig, startSyncEngine } from './lib/syncEngine'
import { getBrandLogo, applyBrandFavicon } from './lib/branding'

async function bootstrap() {
  // 客户专属只读分享路由：#/share?d=xxx —— 不初始化业务数据，直接渲染独立查看器
  if (window.location.hash.startsWith('#/share')) {
    document.title = '单据分享 · 昌发香行'
    const root = document.getElementById('root')!
    root.innerHTML = ''
    createRoot(root).render(
      <StrictMode>
        <ShareViewer />
      </StrictMode>,
    )
    return
  }
  if (window.location.hash.startsWith('#/festival/')) {
    document.title = '产品目录 · 昌发香行'
    const root = document.getElementById('root')!
    root.innerHTML = ''
    createRoot(root).render(<StrictMode><FestivalShareViewer /></StrictMode>)
    return
  }

  // 清理旧版 localStorage 大 key（防止 5MB 配额崩溃再次发生）
  try { cleanupLegacyLocalStorage(); } catch { /* Best-effort operation; failure is non-fatal. */ }

  // 数据初始化仅读取 IndexedDB；全新设备登录后从认证同步接口恢复。
  try {
    await initMockData();
  } catch (e) {
    console.error('数据初始化失败', e);
  }

  // 多设备实时同步：首次访问自动使用同源服务器；认证凭据来自登录会话。
  // 已有配置则尊重用户选择不覆盖。紧接着首屏前以服务器为准全量拉取一轮
  // （8s 超时不阻塞进入；服务器不可达照常离线开单）。
  try {
    ensureSyncConfig();
    await startSyncEngine();
  } catch (e) {
    console.warn('同步引擎启动失败（不影响本地使用）', e);
  }

  const root = document.getElementById('root')!;
  // 清掉启动加载画面，避免 hasChildNodes() 判断导致 App 永不挂载（白屏卡死）
  root.innerHTML = '';
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

// 启动时显示加载画面，数据就绪后挂载应用
// 品牌商标：上传后启动屏与浏览器标签图标即时替换
applyBrandFavicon();
const _brandLogo = getBrandLogo();
const bootLogoHtml = _brandLogo
  ? `<img src="${_brandLogo}" alt="品牌商标" style="width:36px;height:36px;border-radius:10px;object-fit:contain" />`
  : `<div style="width:36px;height:36px;border-radius:10px;background:#059669;display:flex;align-items:center;justify-content:center;color:#fff;font-weight:700;font-size:16px">昌</div>`;
const bootHtml = `
  <div style="display:flex;align-items:center;justify-content:center;height:100vh;flex-direction:column;gap:12px;background:#fafafa">
    ${bootLogoHtml}
    <div style="color:#71717a;font-size:13px">正在加载工作台数据…</div>
  </div>
`;
document.getElementById('root')!.innerHTML = bootHtml;
bootstrap();
